import TimezoneSelect from "react-timezone-select";

const TimezonePicker = ({
  value,
  onChange,
  placeholder = "Select Timezone",
}) => {
  return (
    <TimezoneSelect
      classNamePrefix="timezone-select"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      styles={{
        menu: (base) => ({
          ...base,
          zIndex: 9999,
        }),
      }}
    />
  );
};

export default TimezonePicker;